import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuditTrayDto, UserStaffDetailDto } from '@cradua/data';
import { GatewayFacade } from './../../../../../gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-audittray',
  templateUrl: './audittray.component.html',
  styleUrls: ['./audittray.component.scss']
})
export class AudittrayComponent implements OnInit {
  audittrayForm: FormGroup;
  searchText: string;
  audittrayFormArray: FormGroup;
  @Input() audittrays: AuditTrayDto[] = [];
  @Input() actionedstaff: UserStaffDetailDto[];
  filteredAudittrays = [];
  
  constructor( private fb: FormBuilder, private gatewayFacade: GatewayFacade) { }

  ngOnInit() {
    
     this.audittrayForm = this.fb.group({
      StaffId: [''],
      StartDate: [''],
      EndDate:['']
    });
    this.gatewayFacade.loadGateway('UserStaffDetail').subscribe((data => { this.actionedstaff = data; }));   
    this.fetchAudittray();
  }

  searchRecords() {
   
    this.filteredAudittrays = this.audittrays.filter(
    p => (p.StaffId == this.searchText)  || ( p.ActionDate >= this.audittrayForm.get("StartDate").value && p.ActionDate <= this.audittrayForm.get("EndDate").value) || (p.StaffId == this.searchText && p.ActionDate >= this.audittrayForm.get("StartDate").value && p.ActionDate <= this.audittrayForm.get("EndDate").value)
    );
    //console.log("SEARCH list", this.filteredAudittrays);
  }
  // // actionChanged(event) {
  // //   this.getstaffid(event);
  // //  }
  //  getstaffid(staffId: string) {
     
  //    this.gatewayFacade.getselected('UserStaffDetail').subscribe((data) => {
      
  //      this.populatestate = data;
  //    });
  //  }
  fetchAudittray() {
    this.gatewayFacade.loadGateway("AuditTray").subscribe((audittrayinfo) => {
      this.audittrays = audittrayinfo;
      this.filteredAudittrays = this.audittrays;
    });
  }

  
}
